<template>
<div class="footer">
  <p>
    Made by <a href="https://twitter.com/yujin_gaya">Yujin</a> with ❤️
  </p>
  <p>
    Since 2021
  </p>
</div>
</template>

<script>
export default {
  name: 'Footer',
};
</script>

<style>
.footer p {
  padding: 0 12px;
}
</style>
